import { Provider } from '@kaltura-ott/tvpil';

import { tvpil } from '../compat/tvpil';

export function useProvider(providerName: string): Provider | undefined {
  return tvpil.providersRepository?.providerSettings[providerName];
}
